// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__mVOOy","loaderOuter":"PageOverlayLoader_loaderOuter___G1fB"};